import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, Facebook, Youtube } from "lucide-react";
import {
  CLUB_NAME, CLUB_LOCATION, CLUB_FOUNDED, CLUB_PRESIDENT,
  WHATSAPP_LINK, PHONE_DISPLAY,
} from "../../lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-auto border-t border-border bg-[hsl(218_55%_5%)]"
    >
      <div className="container-x py-14 md:py-20 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Link to="/" className="flex items-center gap-3 mb-5" data-testid="footer-logo">
            <img src="/assets/fcs-logo.png" alt="FCS Logo" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-display text-xl font-black uppercase tracking-wider">{CLUB_NAME}</div>
              <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-primary">Focus Club · {CLUB_FOUNDED}</div>
            </div>
          </Link>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            {CLUB_LOCATION} merkezli çok branşlı spor kulübü. Çocuklar, gençler ve yetişkinler için eğitim,
            gelişim, organizasyon ve sportif başarı odaklı kulüp yapısı.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://instagram.com"
              target="_blank" rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-secondary hover:border-primary hover:text-primary transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank" rel="noreferrer"
              aria-label="Facebook"
              data-testid="footer-social-facebook"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-secondary hover:border-primary hover:text-primary transition-colors"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href="https://youtube.com"
              target="_blank" rel="noreferrer"
              aria-label="Youtube"
              data-testid="footer-social-youtube"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-secondary hover:border-primary hover:text-primary transition-colors"
            >
              <Youtube className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="font-display text-sm font-black uppercase tracking-[0.22em] text-primary mb-4">Keşfet</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/hakkimizda" className="hover:text-primary transition-colors">Hakkımızda</Link></li>
            <li><Link to="/branslar" className="hover:text-primary transition-colors">Spor Branşları</Link></li>
            <li><Link to="/kurslar" className="hover:text-primary transition-colors">Kurslar</Link></li>
            <li><Link to="/etkinlikler" className="hover:text-primary transition-colors">Etkinlikler</Link></li>
            <li><Link to="/antrenor-basvuru" className="hover:text-primary transition-colors">Antrenör Başvuru</Link></li>
            <li><Link to="/galeri" className="hover:text-primary transition-colors">Galeri</Link></li>
            <li><Link to="/duyurular" className="hover:text-primary transition-colors">Duyurular</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="font-display text-sm font-black uppercase tracking-[0.22em] text-primary mb-4">İletişim</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
              <span>{CLUB_LOCATION}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-primary shrink-0" />
              <a href="tel:+905078664360" className="hover:text-primary transition-colors" data-testid="footer-phone">
                {PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-primary shrink-0" />
              <a href="mailto:info@focussporkulubu.com" className="hover:text-primary transition-colors">
                info@focussporkulubu.com
              </a>
            </li>
          </ul>
          <a
            href={WHATSAPP_LINK}
            target="_blank" rel="noreferrer"
            data-testid="footer-whatsapp"
            className="btn-primary mt-6"
          >
            WhatsApp ile İletişim
          </a>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} {CLUB_NAME}. Tüm hakları saklıdır.</p>
          <p className="font-display uppercase tracking-wider">Kulüp Başkanı: <span className="text-foreground">{CLUB_PRESIDENT}</span></p>
          <Link to="/admin/login" className="font-display uppercase tracking-wider opacity-60 hover:opacity-100 hover:text-primary" data-testid="footer-admin-link">Yönetim</Link>
        </div>
      </div>
    </footer>
  );
}
